import { defineStore } from 'pinia'

export const useTaskStore = defineStore({
  id: 'task',
  state: () => ({
    taskTab: '100',
    taskType: 0,
    showTaskSwitch: false,
    orderTab: '' as string | number,
    teamStudyType: 1,
    shopOrderListTab: ''
  }),
  actions: {
    setTaskTab(taskValue: string) {
      this.taskTab = taskValue
    },
    setTaskType(taskTypeValue: number) {
      this.taskType = taskTypeValue
    },
    setShowTaskSwitch(val: boolean) {
      this.showTaskSwitch = val
    },
    setOrderTab(taskValue: string | number) {
      this.orderTab = taskValue
    },
    setTeamStudyType(teamStudyType: number) {
      this.teamStudyType = teamStudyType
    },
    setShopOrderListTab(shopOrderListTab: string) {
      this.shopOrderListTab = shopOrderListTab
    }
  },
  getters: {
    getTaskTab(): string {
      return this.taskTab
    },
    getTaskType(): number {
      return this.taskType
    },
    getShowTaskSwitch(): boolean {
      return this.showTaskSwitch
    },
    getOrderTab(): string | number {
      return this.orderTab
    },
    getTeamStudyType(): number {
      return this.teamStudyType
    },
    getShopOrderListTab(): string {
      return this.shopOrderListTab
    }
  }
})
